<template>
    <rkm-modal
        :buttons="['cancel']"
        :loading="loading"
        title='Viagens agendadas'
        large
        ref="Modal"
        @save="$refs.Form.save()"
    >
        <Form
            :consultaData="consultaData"
            :municipio="municipio"
            ref="Form"
            @save="handleExit"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        id: null,
        municipio: null,
        consultaData: null,
    }),
    methods: {
        open(data, municipio) {

            this.consultaData = data
            this.municipio = municipio
            this.$refs.Modal.show()
        },
        handleExit(motivo) {

            this.$emit('save', motivo.data)
            this.$refs.Modal.hide()
        },
    },
}
</script>